/**
 * W-c19cea34: a model the installed provider CLI is too old to run stays in
 * the picker with a plain reason and the one step that enables it, instead of
 * being left out. The server decides which models wait for an update
 * (`needsProviderVersion`); this module only words it.
 *
 * @module modelProviderVersionGate
 */
import type { ProviderDriverKind } from "@cleo/contracts";

/** The program a person updates: Claude Code for Claude, else the provider's own name. */
export function providerCliName(driverKind: ProviderDriverKind, providerDisplayName: string) {
  return driverKind === "claudeAgent" ? "Claude Code" : providerDisplayName;
}

const versionLabel = (version: string) => version.trim().replace(/^v/iu, "");

/** "Needs Claude Code 2.1.280 or newer; you have 2.1.250." */
export function modelNeedsProviderVersionNote(input: {
  readonly cliName: string;
  readonly needsVersion: string;
  readonly installedVersion: string | null | undefined;
}): string {
  const installed = input.installedVersion?.trim();
  return installed
    ? `Needs ${input.cliName} ${versionLabel(input.needsVersion)} or newer; you have ${versionLabel(installed)}.`
    : `Needs ${input.cliName} ${versionLabel(input.needsVersion)} or newer.`;
}

/** The one step that enables the model. */
export function modelNeedsProviderVersionDoorLabel(cliName: string): string {
  return `Update ${cliName}`;
}
